$(function() {
    const manageLoginToggle = function () {
        let toggleLoginActive = 0;
        const $body = $('body');
        const $loginBtn = $('#authenticatedButton');
        const $loginToggleBox = $('#loginToggleBox');

        let manageFilterOuterClick = function () {
            let loginBtn =  $loginBtn[0];
            let loginToggleBox =  $loginToggleBox[0];
            $(document).on('click', function( event ) {
                if (toggleLoginActive && loginBtn !== event.target && !loginBtn.contains(event.target) && loginToggleBox !== event.target && !loginToggleBox.contains(event.target)) {
                    closeLoginToggle();
                    return false;
                }
            });
        }

        const openLoginToggle = function () {
            $loginBtn.attr('aria-expanded', 'true');
            $loginToggleBox.addClass('activeBox');
            toggleLoginActive = 1;
            manageFilterOuterClick();
            if (!Revealizr.isDesktopSize) {
                $body.addClass('overflow-hidden');
            }
        }

        const closeLoginToggle = function () {
            $loginBtn.attr('aria-expanded', 'false');
            $loginToggleBox.removeClass('activeBox');
            toggleLoginActive = 0;
            if (!Revealizr.isDesktopSize) {
                $body.removeClass('overflow-hidden');
            }
        }

        $loginBtn.on('click', function() {
            if (toggleLoginActive) {
                closeLoginToggle();
            } else {
                openLoginToggle();
            }
        });
        $('.close-login-box').on('click', function() {
            closeLoginToggle();
        });
    }

    manageLoginToggle();
});